export const ReviewDesc = [
  {
    text: '권오훈 변호사님께 두 번째 상담 받았는데요. 정말 명쾌하고 친절하게 바로 알아들을 수 있게 설명 주셨습니다. 권오훈 변호사님 전에 다른분께 한 번 상담받았는데 너무 돈 아까워서 아 엑스퍼트 이 서비스 별로인가 했었거든요. 근데 권오훈변호사님은 달라요. 궁금한 부분이 완전히 해결됐는지도 확인하시고 법령을 참고로 보내주기도 하시고 법 관련 궁금한 사항이 있으면 바로 또 상담의뢰 드릴 예정입니다.',
    id: '스파디****',
  },
  {
    text: '우선 친절한 상담 감사합니다. 그리고 생각보다 자세히 알려주신 것 같습니다. 다음에도 또 이용할 일이 생기면 변호사님을 찾을 것 같습니다. :)',
    id: 'luck****',
  },
  {
    text: '자꾸 잊으시고 오바타임으로 상담해주셔서 몸둘바를 모르겠네요. 진짜 너무 초조해서 엑스퍼트 이용만 4명, 로톡에서 2명, 이 상담료만 해도 이미 한시간 직접 방문 상담가격보다 더 쓴 것일텐데 초조하고 불안해서 자꾸 전확 붙들게 되더라구요. 그런데 명확하고 객관적이면서도 전문적인 설명을 해주셔서 전 이제 맘 놓고 제 할일 하러갑니다.',
    id: 'yuio****',
  },
  {
    text: '고민할 필요없이 상담 요청하세요. 전문성은 말할것도 없이 분쟁에 대해 명확한 설명으로 이해하기 쉽도록 정말 친절하게 설명해주십니다. 권오훈 변호사님 다시 한번 감사합니다 :)',
    id: 'myal****',
  },
  {
    text: '명확한 설명으로 걱정했던 부분을 지혜롭게 잘 헤쳐나갈 수 있게 늦은 시간까지 도와주신 변호사님께 대단히 고개숙여 감사의 인사를 드리고 싶습니다~다시 한번 정말 감사드립니다~!!',
    id: 'So****',
  },
  {
    text: '정말 늦은시간임에도 불구하고 친절하게 자세하게 도와주셔서 너무 감사드립니다! 도움이 많이 되었어요. 변호사님 조언 듣길 정말 다행이에요..',
    id: 'iamy****',
  },
  {
    text: '얼마전에도 변호사님 상담을 통해 큰 도움을받았습니다~도움될만한 자료등도첨부해주시고 정말도 성심성의를다해주신 상담으로 큰 도움이 되서 진심으로 감사드리네요~터무니 없는 상담비용에도 전문적이고 친절한 상담 감사합니다^^',
    id: 'el****',
  },
  {
    text: '하루종일 심란한 마음에 어떻게 해야할지 몰랐는데요..또 이렇게 도움을 주시니..이해하기 쉽고 제상황에서 뭘해야할지 빠르게 알려주시니 힘이 납니다..너무 감사합니다',
    id: 'mojo****',
  },
  {
    text: '상담할 때 제가 다소 어수선해서 질문의 갈피를 잡기 힘들었는데 명확하게 요점을 찝어 주셨습니다. 사례나 대응 방안도 찾아서 설명해주셨어요! 약간 걱정이 덜해지네요. 감사합니다',
    id: 'ni****',
  },
  {
    text: '믿음직한 경력 / 합리적인 의견제시 / 명확한 법적근거 / 저렴한 상담비용 / 법에 대해 무지한 사람도 상담만으로 타당한 의견을 제시받아 난관을 해쳐나갈수 있게 해주시는 개인적으로 엑스퍼트에서 가장 신뢰하고 믿음을 주시는 변호사님 이십니다',
    id: '묘한****',
  },
];
